'use client'

import React from 'react'
import { Image } from '@contentsite/src/graphql/generated/graphql-types'
import ImageComponent from '@dustin-web/microsite-components/src/image/image-nowidth'
import { useResponsive } from '@dustin-web/microsite-components/src/hooks'

type Props = {
  image: Image
  imageAltText?: string
  name: string
  htmlContent: string
}

export const AboutBlock = (props: Props) => {
  const { breakpoints } = useResponsive()
  return (
    <div className="u-py-24 u-bg-white">
      <div className="container">
        <div className="row">
          <div className="col-md-10">
            <div className="u-mb-24 d-flex justify-content-between align-items-center">
              {props.name ? <h2 className="h1 u-mb-0 u-mr-16">{props.name}</h2> : null}
              {breakpoints.max.MD && props.image ? (
                <ImageComponent
                  src={props.image.url}
                  alt={props.imageAltText || props.name}
                  height={42}
                />
              ) : null}
            </div>
            {props.htmlContent ? (
              <div dangerouslySetInnerHTML={{ __html: props.htmlContent }}></div>
            ) : null}
          </div>
          <div className="col-md-2 d-flex justify-content-center align-items-center">
            {breakpoints.min.MD && props.image ? (
              <ImageComponent
                src={props.image.url}
                alt={props.imageAltText || props.name}
                height={42}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}
